import queryString from 'query-string'

const queryStringify = (data: Record<string, any>) => {
  if (!Object.keys(data).length) return ''

  const stringify = queryString.stringify(data, {
    skipNull: true,
    skipEmptyString: true,
  })

  return `?${stringify}`
}

export const convertParams = (url: string, params: Record<string, any>) => {
  Object.keys(params).forEach((key) => {
    url = url.replace(
      '${' + key + '}',
      params[key] !== undefined ? String(params[key]) : '',
    )
  })
  return url
}

export default queryStringify
